"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToday = exports.getThisYear = exports.getThisMonth = exports.getThisWeek = exports.getLastWeek = exports.getLastMonth = exports.getLastYear = void 0;

var luxon_1 = require("luxon");

var getLastYear = function getLastYear() {
  var lastYearStartDate = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.local().startOf("year").toISODate())).plus({
    day: 1
  }).minus({
    year: 1
  }).toFormat("MM/dd/yyyy");
  var lastYearEndDate = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.local().endOf("year").toISODate())).plus({
    day: 1
  }).minus({
    year: 1
  }).toFormat("MM/dd/yyyy");
  return {
    startDate: lastYearStartDate,
    endDate: lastYearEndDate
  };
};

exports.getLastYear = getLastYear;

var getLastMonth = function getLastMonth() {
  var lastMonthStartDate = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.local().startOf("month").toISODate())).plus({
    day: 1
  }).minus({
    month: 1
  }).toFormat("MM/dd/yyyy");
  var lastMonthEndDate = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.local().startOf("month").toISODate())).toFormat("MM/dd/yyyy");
  return {
    startDate: lastMonthStartDate,
    endDate: lastMonthEndDate
  };
};

exports.getLastMonth = getLastMonth;

var getLastWeek = function getLastWeek() {
  var lastWeekStartDate = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.now().startOf("week").toISODate())).minus({
    days: 6
  }).toFormat("MM/dd/yyyy");
  var lastWeekEndDate = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.now().endOf("week").toISODate())).minus({
    days: 6
  }).toFormat("MM/dd/yyyy");
  return {
    startDate: lastWeekStartDate,
    endDate: lastWeekEndDate
  };
};

exports.getLastWeek = getLastWeek;

var getThisWeek = function getThisWeek() {
  var thisWeekStartDate = luxon_1.DateTime.local().startOf("week").toFormat("MM/dd/yyyy");
  var thisWeekEndDate = luxon_1.DateTime.local().endOf("week").toFormat("MM/dd/yyyy");
  return {
    startDate: thisWeekStartDate,
    endDate: thisWeekEndDate
  };
};

exports.getThisWeek = getThisWeek;

var getThisMonth = function getThisMonth() {
  var thisMonthStartDate = luxon_1.DateTime.local().startOf("month").toFormat("MM/dd/yyyy");
  var thisMonthEndDate = luxon_1.DateTime.local().endOf("month").toFormat("MM/dd/yyyy");
  return {
    startDate: thisMonthStartDate,
    endDate: thisMonthEndDate
  };
};

exports.getThisMonth = getThisMonth;

var getThisYear = function getThisYear() {
  var thisYearStartDate = luxon_1.DateTime.local().startOf("year").toFormat("MM/dd/yyyy");
  var thisYearEndDate = luxon_1.DateTime.local().endOf("year").toFormat("MM/dd/yyyy");
  return {
    startDate: thisYearStartDate,
    endDate: thisYearEndDate
  };
};

exports.getThisYear = getThisYear;

var getToday = function getToday() {
  var today = luxon_1.DateTime.fromJSDate(new Date(luxon_1.DateTime.local().toISODate())).plus({
    day: 1
  }).toFormat("MM/dd/yyyy");
  return {
    startDate: today,
    endDate: today
  };
};

exports.getToday = getToday;
var DateRangeUtilities = {
  getLastYear: exports.getLastYear,
  getLastMonth: exports.getLastMonth,
  getLastWeek: exports.getLastWeek,
  getThisWeek: exports.getThisWeek,
  getThisYear: exports.getThisYear,
  getToday: exports.getToday,
  getThisMonth: exports.getThisMonth
};
exports.default = DateRangeUtilities;